export default __webpack_public_path__ + "static/media/feature4_3.78b644a9.png";